export default Object.freeze({
  SPOUSE: {relationshipId: 1, relationship: 'Spouse', relationshipCode: 'SPOUSE'},
  PARENT: {relationshipId: 2, relationship: 'Parent', relationshipCode: 'PARENT'},
  CHILD: {relationshipId: 3, relationship: 'Child', relationshipCode: 'CHILD'},
  SIBLING: {relationshipId: 4, relationship: 'Sibling', relationshipCode: 'SIBLING'},
  EXTENDED_FAMILY: {relationshipId: 5, relationship: 'Extended family', relationshipCode: 'EXTENDED_FAMILY'},
  FAMILY_IN_LAW: {relationshipId: 6, relationship: 'Family-in-law', relationshipCode: 'FAMILY_IN_LAW'},
  OTHER: {relationshipId: 7, relationship: 'Other', relationshipCode: 'OTHER'},
});
